import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { ButtonGroup, Button, OverlayTrigger, Popover, Glyphicon, } from 'react-bootstrap';
import Checkbox from 'components/v2/forms/Checkbox';
import { titleize } from 'underscore.string';
import { sluggify } from 'utils/localization/utils';
class StatusFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            actives: this.props.actives,
        };
    }
    onChange(status) {
        return (checked) => {
            const state = Object.assign({}, this.state);
            if (!status) {
                state.actives = [];
            }
            else if (checked) {
                state.actives.push(status);
            }
            else {
                const idx = state.actives.indexOf(status);
                state.actives.splice(idx, 1);
            }
            this.setState(state);
            this.props.onChange(state.actives);
        };
    }
    getClearButton() {
        if (!this.props.clear) {
            return '';
        }
        const { t } = this.props;
        return (React.createElement("div", null,
            React.createElement(ButtonGroup, { className: "mb-2 status-button-group" },
                React.createElement(Button, { active: this.state.actives === 'clear', onClick: this.onChange() }, titleize(t('CLEAR')))),
            React.createElement("hr", { className: "my-2" })));
    }
    renderPopup() {
        const { t } = this.props;
        return (React.createElement(Popover, { id: "status-popup", className: "filter-dropdown-wrapper" },
            this.getClearButton(),
            React.createElement("ul", { className: "space-y-2" }, this.props.items.map((status) => (React.createElement("li", { key: status },
                React.createElement(Checkbox, { checked: this.props.actives.indexOf(status) > -1, onChange: this.onChange(status), id: status, name: status }, (t(sluggify(status))))))))));
    }
    render() {
        return (React.createElement("div", { className: this.props.className },
            React.createElement(OverlayTrigger, { className: this.props.className, rootClose: true, trigger: "click", placement: "bottom", overlay: this.renderPopup() },
                React.createElement("div", null,
                    React.createElement(Button, { bsStyle: "default", style: { outline: 'none' } },
                        this.props.title,
                        React.createElement(Glyphicon, { glyph: "chevron-down", className: "button-down-glyph" }))))));
    }
}
StatusFilter.propTypes = {
    clear: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    items: PropTypes.array.isRequired,
    actives: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
};
export default withTranslation()(StatusFilter);
